module.exports = __webpack_public_path__ + "static/media/secondary-2-science.2e7b8e30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/secondary-2-science.jpg
// module id = 170
// module chunks = 0